/**
* Pain Points CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Pain Points CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'pain-points-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const component = document.querySelector( '.pain-points-cta' );
      if ( component ) {
        const lines = component.querySelectorAll( '.pain-points-cta__draw' );
        const circles = component.querySelectorAll( '.pain-points-cta__circle' );

        gsap.set( lines, {
          scaleX: 0,
          transformOrigin: '100% 50%',
        } );

        gsap.set( circles, {
          scale: 0,
          transformOrigin: 'center center',
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        } );

        lines.forEach( ( line, i ) => {
          tl.to( line, {
            scaleX: 1,
            duration: 1,
            ease: 'power2.out',
          }, i * 0.6 )
              .to( circles[i], {
                scale: 1,
                duration: 0.3,
                ease: 'back.out(1.7)',
              }, i * 0.6 + 1 );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'pain-points-cta', COMPONENT );
} )( app );
